import React from 'react';
import { BorderBottom, type BorderBottomProps } from './Variants/BorderBottom/BorderBottom';
import { Outline, type OutlineProps } from './Variants/Outline/Outline';
import { OutlinePassword, type OutlinePasswordProps } from './Variants/OutlinePassword/OutlinePassword';

export const InputVariants = {
  BORDER_BOTTOM: 'BorderBottom',
  OUTLINE: 'Outline',
  OUTLINE_PASSWORD: 'OutlinePassword',
} as const;

type InputProps =
  | ({ variant: typeof InputVariants.BORDER_BOTTOM } & BorderBottomProps)
  | ({ variant: typeof InputVariants.OUTLINE } & OutlineProps)
  | ({ variant: typeof InputVariants.OUTLINE_PASSWORD } & OutlinePasswordProps);

export const Input: React.FC<InputProps> = React.memo((props) => {
  switch (props.variant) {
    case InputVariants.BORDER_BOTTOM:
      return <BorderBottom {...props} />;
    case InputVariants.OUTLINE:
      return <Outline {...props} />;
    case InputVariants.OUTLINE_PASSWORD:
      return <OutlinePassword {...props} />;
  }
});

Input.displayName = 'Input';
